<template>
    <WhiteIQOS required :title="$t('integrations.poster_integration.import_title')">
        <div class="mt-16 w-100">
            <BaseButton class="w-100" variant="secondary" color="v1-grey-10" size="md" @click="showImportMenuUI"
                :disabled="busy">{{ $t("integrations.poster_integration.import_menu") }}</BaseButton>
        </div>

        <InfoModal @close="goToMenus" v-if="askingImportMenu">
            {{ $t("integrations.poster_integration.warning_menu") }}
        </InfoModal>
    </WhiteIQOS>
</template>

<script>
import ResicoAPI from "@/api/resico";

import InfoModal from "@/components/modals/InfoModal.vue";

import DashboardButton from "@/components/DashboardButton.vue";

export default {
    components: {
        DashboardButton,
        InfoModal,
    },
    data () {
        return {
            askingImportMenu: false,
            importingMenu: false,
            busy: false,
        };
    },
    methods: {
        onImportMenu () {
            this.busy = true;

            ResicoAPI.importMenu(this.cafe._id).then(data => {
                this.goToMenus();
            }).catch(err => {
                if (err.response) {
                    alert(err.response.data.message)
                } else {
                    alert(err.message)
                }
            })
        },
        showImportMenuUI () {
            this.onImportMenu();
        },
        goToMenus () {
            this.$router.push("/menus");
        },
    },
    mounted () {
        ResicoAPI.getProducts(this.cafe._id);
    },
    computed: {
        resico () {
            return this.$store.state.cafe.resico;
        },
        cafe () {
            return this.$store.state.cafe;
        },
    },
};
</script>

<style scoped>
.poster-logo {
    width: auto;
    height: 5vh;
    margin-right: 1vh;
}

.header {
    display: flex;
}

.header h3 {
    position: relative;

    line-height: normal;
    font-size: 4vh;
}

p {
    margin: 0;
    font-size: 2vh;
    padding-top: 1.1vh;
}

.actions {
    /* margin-top: 1vh; */
}

.square-button-green {
    width: 100%;
}

/* .import-button {
    margin-top: 1vh;
  } */
</style>